export default __webpack_public_path__ + "static/media/VISCOUS JELLYSTERRY.0e32d4e9.jpg";